export default __webpack_public_path__ + "static/media/enter (1) 1.fdb8566b.svg";